"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBStepRelasedNegative = function SvgBStepRelasedNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M71.874 78.07C51.334 78.048 34.383 62 33.239 41.492H15.454a2.107 2.107 0 01-2.108-2.107A34.37 34.37 0 00.766 12.777a2.108 2.108 0 012.683-3.252 38.585 38.585 0 0114.049 27.753h17.8c1.163 0 2.107.944 2.107 2.108-.01 17.23 12.708 31.821 29.779 34.166 17.07 2.344 33.25-8.278 37.887-24.873a2.108 2.108 0 014.06 1.138C104.417 66.5 89.209 78.032 71.874 78.069zM2.164 69.682a2.107 2.107 0 01-1.35-3.73 34.314 34.314 0 0011.24-17.273 2.108 2.108 0 114.06 1.138 38.473 38.473 0 01-12.602 19.38c-.379.314-.856.486-1.348.485zM129.712 31.554c-.192 0-.384-.03-.569-.085a2.107 2.107 0 01-1.46-2.599 38.494 38.494 0 0112.58-19.289 2.107 2.107 0 112.683 3.246 34.265 34.265 0 00-11.204 17.188 2.107 2.107 0 01-2.03 1.539z"
  }), (0, _core.jsx)("path", {
    d: "M141.66 69.724a2.109 2.109 0 01-1.334-.485 38.536 38.536 0 01-14.049-27.746h-17.834a2.107 2.107 0 01-2.108-2.107c.01-17.217-12.685-31.8-29.739-34.163-17.054-2.362-33.235 8.221-37.906 24.792a2.107 2.107 0 01-4.053-1.145C39.77 10.65 57.331-1.18 76.144.91s33.35 17.488 34.357 36.39h17.849c1.163 0 2.107.943 2.107 2.107a34.37 34.37 0 0012.56 26.601 2.107 2.107 0 01.28 2.972 2.108 2.108 0 01-1.636.744z"
  }), (0, _core.jsx)("path", {
    d: "M69.282 52.957a2.107 2.107 0 01-1.49-.611L54.63 39.182a2.107 2.107 0 112.971-2.978L69.282 47.87l20.42-20.42a2.107 2.107 0 012.978 2.979L70.77 52.339c-.394.395-.93.617-1.488.618z"
  })));
};

var _default = SvgBStepRelasedNegative;
exports["default"] = _default;